<template>
  <div
    class="Accordion"
    :data-expanded="isExpanded"
    :inert="!isExpanded"
  >
    <div class="Accordion__content">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  isExpanded: boolean,
}>();
</script>

<style lang="scss" scoped>
.Accordion {
  --transitionDuration: 250ms;
  display: grid;
  grid-template-rows: 1fr;
  overflow: hidden;

  transition: grid-template-rows var(--transitionDuration);

  &[data-expanded="false"] {
    grid-template-rows: 0fr;
  }
}

.Accordion__content {
  min-height: 0;
  transition: visibility var(--transitionDuration);

  .Accordion[data-expanded="false"] > & {
    visibility: hidden;
    pointer-events: none;
  }
}
</style>
